import React from "react";
import { Link } from "react-router-dom";
import "./AboutCompany.css";
import aboutImg from "../../assets/aboutUspage/denviaCollageImage.jpg"; // replace with your actual image path

const AboutCompany = () => {
  return (
    <section
      id="aboutus-section"
      className="about-section common-padding"
      data-aos="fade-up"
      data-aos-duration="2000"
    >
      <div className="container aboutus-container">
        {/* Left Content */}
        <div className="aboutus-left">
          <div className="section-title">
            <span>About Us</span>
            <h2>Creating Confident Smiles with Care and Precision</h2>
          </div>

          <div className="about-us-content">
            <p>
              <span className="denvia-bold-name">Denvia Dental Clinic</span> is
              dedicated to transforming smiles through advanced dental care and
              modern technology. Our experienced team provides personalized
              treatments in a warm, relaxing environment—making every visit
              comfortable and stress-free.
              <br />
              <br />
              From preventive care and cosmetic dentistry to full-mouth
              rehabilitation, we combine expertise with compassion to ensure our
              patients achieve the healthiest, most radiant smiles.
            </p>

            <Link to="/about" className="know-more">
              Know More
            </Link>
          </div>
        </div>

        {/* Right Image */}
        <div className="aboutus-right">
          <img src={aboutImg} alt="About Denvia Dental Clinic" />
        </div>
      </div>
    </section>
  );
};

export default AboutCompany;
